import { render, staticRenderFns } from "./DadosCartaoComponent.vue?vue&type=template&id=14e4d48b&"
import script from "./DadosCartaoComponent.vue?vue&type=script&lang=js&"
export * from "./DadosCartaoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports